/**************************************************************************************************
 *
 *  This is the main container for all company related views: Company Detail (hierarch), Company
 *  Edit/Creation, Build Edit/Creation, Task Detail, Field Task Detail
 *
 *  This views are individual components that will fit into the detail-container parent element
 *  defined in this container.
 *
**************************************************************************************************/

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Home from '../../containers/Home';
import ErrorPage from '../../containers/ErrorPage';
import BasePage from '../../baseClasses/BasePage';
import Header from '../../components/Header';
import CompaniesNav from './CompaniesNav';
import CompanyCRUD from './CompanyCRUD';
import './CompaniesContainer.scss';
import dataModel from '../../models/DataModel';

export class CompaniesContainer extends BasePage {

  constructor(props) {
    super(props);

    this.state = {
      selectedCompany: {},
    };
  
    this.handleSelectCompany = this.handleSelectCompany.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.currentCompany) {
      this.setState({ selectedCompany: this.props.currentCompany });
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.match.params.company_id && prevProps.match.params.company_id) {
      this.navigateToCompany(prevProps.match.params.company_id);
    }
  }

  navigateToCompany(companyId, forceUpdate=false) {
    const { history } = this.props;
    const route = {      
      pathname: '/companies/' + companyId,
      state: { forceUpdate, companyId },
    };
    if (history.location.pathname == '/companies') {
      // avoid back button redirect loop between /companies and /companies/{id}
      history.replace(route);
    }
    else {
      history.push(route);
    }
  }

  handleCompanyEditDone(company) {
    this.setState({ selectedCompany: company });
    this.handleSelectCompany(company);
  }

  getSystemPopupView() {
    if (this.props.systemPopup) {
      return this.props.systemPopup;
    }
    else {
      return null;
    }
  }

  handleSelectCompany(company) {
    const { currentUser } = this.props;

    if (company) {
    
      if (!company.is_vendor_company) {
        dataModel.companiesDAO.getCurrentCompany(company.id).then(fetchedCompany => {
          if (fetchedCompany) {
            //set edit permissions - company admins can edit their primary company, and super users can edit all companies
            if (fetchedCompany && (currentUser.super_admin || (currentUser.role.name == 'admin' && +localStorage.primary_company_id == fetchedCompany.id))) {
              dataModel.companiesDAO.setCompanyReadOnly(fetchedCompany, false);
            }
            else {
              dataModel.companiesDAO.setCompanyReadOnly(fetchedCompany, true);
            }
      
            this.setState({ selectedCompany: fetchedCompany });
            this.navigateToCompany(fetchedCompany.id);
            if (!this.props.currentCompany || this.props.currentCompany.id != fetchedCompany.id) {
              dataModel.companiesDAO.setCurrentCompany(fetchedCompany);
            }
          }
        });
      }
      else {
        this.setState({ selectedCompany: company });
      }
    }
  }

  render() {
    const { currentCompany } = this.props;
    if (this.props.catastrophicError) {
      return <ErrorPage catastrophicError={this.props.catastrophicError} />;
    }
    let waitSpinner = null;
    if (dataModel.inProgress) {
      waitSpinner = <Home type="transparent" />;
    }

    if (!dataModel.textMap) {
      dataModel.textMap = this.textMap;
    }
    this.setWhiteLabels(this.props.currentCompany);

    const selectedCompany = this.state.selectedCompany;

    let view = null;

    if (selectedCompany && selectedCompany.id) {
      view = <CompanyCRUD 
              id={selectedCompany.id} 
              key={'company-crud-' + selectedCompany.id} 
              isDialog={true}
              company={selectedCompany} 
              readOnly={!!selectedCompany.readOnly || selectedCompany.is_vendor_company}
        handleCompanyEditDone={this.handleCompanyEditDone} 
        companyDeleted={this.handleCompanyDeleted}
        selectCompany={this.handleSelectCompany} 
              />;
    }

    let companyNavigator = null;
    if ((selectedCompany && selectedCompany.id) || currentCompany) {
      companyNavigator = <CompaniesNav 
        selectedCompany={selectedCompany ? selectedCompany : currentCompany} 
        selectCompany={this.handleSelectCompany}
        readOnly={selectedCompany && (!!selectedCompany.readOnly || selectedCompany.is_vendor_company)}
      />;
    }

    const systemPopup = this.getSystemPopupView();
    return (
      // Replace with the appropriate HTML
      <div className="companies-container">
        {systemPopup}
        <Header companies={this.state.companies} selectedPage="companies"/>
        <div className="companies-body">
          {waitSpinner}
          <div className="nav-container">
            {companyNavigator}
          </div>
          <div className="detail-container" id="companies-detail-container" >
            {view}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    catastrophicError: state.main.catastrophicError,
    permissions: state.new_users.permissions,
    systemPopup: state.main.systemPopup,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    needsLogin: state.main ? state.main.needsLogin : null,
  };
};

export default withRouter(connect(mapStateToProps)(CompaniesContainer));



// WEBPACK FOOTER //
// ./src/containers/CompaniesContainer/index.js